'use strict';

(function() {
  // Store Ajaxinate
  var endlessScroll = null;

  // Number of loaded pages (1 = initial page)
  var currentLoadedPage = 1;

  // sessionStorage key for preserving collection state
  var collectionStateKey = 'collectionState_' + window.location.pathname + window.location.search;

  // Saved state (scroll position, items count, page)
  var targetState = null;

  // Flag indicating that we are auto-loading pages to restore scroll position
  var isRestoringScroll = false;

  // Try to read state from storage (when returning from product page)
  try {
    var savedStateRaw = window.sessionStorage.getItem(collectionStateKey);
    if (savedStateRaw) {
      targetState = JSON.parse(savedStateRaw);
      window.sessionStorage.removeItem(collectionStateKey);
    }
  } catch (e) {
    console.error('Failed to parse collection state from sessionStorage', e);
  }

  // Helper: attach listeners to all product links
  // so before navigating to product we save current scroll and Ajaxinate state
  function attachProductLinkListeners() {
    var productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    var productLinks = productGrid.querySelectorAll('a');
    if (!productLinks.length) return;

    productLinks.forEach(function(link) {
      // Avoid duplicate listeners
      if (link.dataset.collectionScrollBound === 'true') return;
      link.dataset.collectionScrollBound = 'true';

      link.addEventListener('click', function() {
        try {
          var stateToSave = {
            scrollY: window.scrollY || window.pageYOffset || 0,
            itemsCount: productGrid.children.length,
            page: currentLoadedPage
          };

          window.sessionStorage.setItem(collectionStateKey, JSON.stringify(stateToSave));
        } catch (e) {
          console.error('Failed to save collection state to sessionStorage', e);
        }
      });
    });
  }

  // Helper: modify Ajaxinate URL by appending section_id and current query params
  function modifyUrlWithSectionAndParams(urlString, sectionId) {
    if (!urlString) return urlString;

    try {
      var url = urlString.startsWith('http')
        ? new URL(urlString)
        : new URL(urlString, window.location.origin);

      if (sectionId && !url.searchParams.has('section_id')) {
        url.searchParams.set('section_id', sectionId);
      }

      // Append current params (filters, sort, etc) without overriding section_id and page
      var currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach(function(value, key) {
        if (key !== 'section_id' && key !== 'page' && !url.searchParams.has(key)) {
          url.searchParams.set(key, value);
        }
      });

      return url.toString();
    } catch (e) {
      console.error('Error modifying URL:', e);
      return urlString;
    }
  }

  // Auto-load pages up to targetState.page before final scroll restore
  function autoLoadPagesUntilTarget(sectionId) {
    if (!endlessScroll || !targetState || !targetState.page || currentLoadedPage >= targetState.page) {
      // Enough pages loaded — we can restore scroll position
      if (targetState && typeof targetState.scrollY === 'number') {
        window.scrollTo(0, targetState.scrollY);
      }
      isRestoringScroll = false;
      targetState = null;
      return;
    }

    var paginationElement = document.querySelector('#AjaxinatePagination');
    if (!paginationElement) {
      // No more pages — still try to restore scroll
      if (targetState && typeof targetState.scrollY === 'number') {
        window.scrollTo(0, targetState.scrollY);
      }
      isRestoringScroll = false;
      targetState = null;
      return;
    }

    var nextLink = paginationElement.querySelector('a');
    if (!nextLink) {
      if (targetState && typeof targetState.scrollY === 'number') {
        window.scrollTo(0, targetState.scrollY);
      }
      isRestoringScroll = false;
      targetState = null;
      return;
    }

    // Prepare next URL for Ajaxinate and trigger load
    endlessScroll.nextPageLinkElement = nextLink;
    endlessScroll.nextPageUrl = modifyUrlWithSectionAndParams(nextLink.href, sectionId);

    isRestoringScroll = true;
    endlessScroll.loadMore();
  }

  // Initialize Ajaxinate instance
  function initializeAjaxinate() {
    // Destroy previous instance if exists
    if (endlessScroll && typeof endlessScroll.destroy === 'function') {
      endlessScroll.destroy();
    }

    // Start from first page
    currentLoadedPage = 1;

    // Check if pagination container exists
    var paginationElement = document.querySelector('#AjaxinatePagination');
    if (!paginationElement || !paginationElement.querySelector('a')) {
      return;
    }

    // Get section ID from product-grid
    var productGrid = document.getElementById('product-grid');
    var sectionId = productGrid ? productGrid.getAttribute('data-id') : null;

    // Create new Ajaxinate instance with settings
    endlessScroll = new Ajaxinate({
      method: 'scroll',
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      offset: 0,
      loadingText: 'Loading...',
      callback: function(responseXML) {
        // Increase page counter after each successful load
        currentLoadedPage += 1;

        // Callback after new page is loaded
        if (typeof window.initializeScrollAnimationTrigger === 'function') {
          var container = document.querySelector('#product-grid');
          if (container) {
            window.initializeScrollAnimationTrigger(container.innerHTML);
          }
        }

        // After each load, check if we need to keep loading for scroll restore
        if (isRestoringScroll && targetState && targetState.page && currentLoadedPage <= targetState.page) {
          autoLoadPagesUntilTarget(sectionId);
        }

        // New products — (re)attach listeners to product links
        attachProductLinkListeners();
      }
    });

    // Intercept loadMore to inject section_id and current params
    if (sectionId && endlessScroll) {
      var originalLoadMore = endlessScroll.loadMore;

      endlessScroll.loadMore = function() {
        if (this.nextPageUrl) {
          this.nextPageUrl = modifyUrlWithSectionAndParams(this.nextPageUrl, sectionId);
        }
        return originalLoadMore.call(this);
      };
    }

    // Attach listeners to product links (to save scrollY before navigation)
    attachProductLinkListeners();

    // Restore state if we have it
    if (targetState && typeof targetState.scrollY === 'number') {
      // If more than one page was loaded previously — auto-load pages
      if (targetState.page && targetState.page > 1) {
        autoLoadPagesUntilTarget(sectionId);
      } else {
        // If only first page was used — we can scroll immediately
        window.scrollTo(0, targetState.scrollY);
        targetState = null;
      }
    }
  }

  // Initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAjaxinate);
  } else {
    // DOM is already loaded
    setTimeout(initializeAjaxinate, 100);
  }

  // Expose helper globally so facets.js can reinitialize Ajaxinate
  window.initializeCollectionAjaxinate = initializeAjaxinate;
})();


